module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gr-969458b727378ff7b215343cfc6c9165.svg";